<template>
  <div class="platform_list">
    <!--平台公告列表头部-->
    <div class="platform_list_top">
      <div><input type="text" v-model.trim="title" title="公告标题" placeholder="公告标题"></div>
      <div>
        <el-date-picker
          v-model.trim="startTime"
          type="date"
          placeholder="开始时间"
          default-time="00:00:00"
          format="yyyy/MM/dd">
        </el-date-picker>
      </div>
      至
      <div style="margin-left: 1%">
        <el-date-picker
          v-model.trim="endTime"
          type="date"
          placeholder="结束时间"
          default-time="00:00:00"
          format="yyyy/MM/dd">
        </el-date-picker>
      </div>
      <div>
        <input type="checkbox" v-model="top" title="只显示置顶公告" id="placed_at_the_top">
        <label for="placed_at_the_top">只显示置顶公告</label>
      </div>
      <button class="btn_normal w116 ml10" @click="queryData()">查询</button>
    </div>

    <!--平台公告列表信息-->
    <div class="platform_list_msg">
      <!--表格-->
      <table class="table">
        <thead>
        <tr>
          <th>公告标题</th>
          <th>发布时间</th>
          <th>？置顶</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody v-if="list.length">
        <tr v-for="(item, index) in list" :key="index">
          <td>{{item.Title}}</td>
          <td>{{item.PubTime | time}}</td>
          <td>{{item.IsTop | isTop}}</td>
          <td><a title="查看详情" @click="ctrlBtn('pAnnounceDetail', item.Id)">查看详情</a></td>
        </tr>
        </tbody>
        <tbody v-if="!list.length">
        <tr>
          <td colspan="4">暂时没有相关的数据</td>
        </tr>
        </tbody>
      </table>

      <!--分页-->
      <div v-if="list.length" class="text_right mt20">
        <el-pagination
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!--弹出框-->
    <platform-list-embed-msg v-if="isShow" :title="dialogTitle" :announceMsgId="noticeId"
                         :showType="dialogShowType" @cancelbtn="getSelectDialogEmbed"></platform-list-embed-msg>

    <!--提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeTipsDialog"></msg-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>
  </div>
</template>

<script>
  import PlatformListEmbedMsg from './platform-list-embed-msg';
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: 'platform-list',
    components: {PlatformListEmbedMsg, LoadingDialog, MsgDialog},
    data() {
      return {
        list: [], // 平台公告列表
        noticeId: null, // 公告id
        title: '', // 公告标题
        startTime: '', // 开始时间
        endTime: '', // 结束时间
        top: false, // 是否置顶
        announceMsg: '', // 公告详情
        isLoading: false, // 是否显示加载框
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 10 // 总条数
      }
    },
    methods: {
      // 根据公告标题 + 开始时间 + 结束时间 + 是否只显示置顶公告
      queryData() {
        if (this.startTime && !this.endTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入结束时间';
        } else if (!this.startTime && this.endTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入开始时间';
        } else if (this.startTime > this.endTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '开始时间不能大于结束时间';
        } else {
          this.currentPage = 1;
          this.getList();
        }
      },

      // 获取平台公告分页数据
      getList() {
        this.list = [];
        this.isLoading = true;
        const params = {
          NoticeName: this.title,
          BeginCreateTime: this.Global.timeFormatStart(this.startTime),
          EndCreateTime: this.Global.timeFormatEnd(this.endTime),
          IsTop: this.top,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.loadPlatNoticePageData, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            if (res) {
              clearTimeout(timer);
              if (!res.data.errorMsg.length) {
                self.list = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        }).catch((err) => {
          console.log('公告列表错误');
          console.log(err);
        });
      },

      // 操作按钮
      ctrlBtn(type, announceMsg) {
        this.isShow = true;
        this.dialogShowType = type;
        this.dialogTitle = '平台公告详情';
        this.noticeId = announceMsg;
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
      },

      // 关闭提示框
      closeTipsDialog(e) {
        this.isMsg = e;
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        this.getList();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getList();
      }
    },
    created() {
      if (this.$route.query['title']) {
        this.title = this.$route.query['title'];
      }
      this.getList();
    },
    activated() { // 只有keep-alive激活才会被使用
      if (sessionStorage.getItem('isRefresh') === 'true') { // 从左边的菜单进去刷新页面
        sessionStorage.setItem('isRefresh', 'false');
        this.title = '';
        this.startTime = '';
        this.endTime = '';
        this.top = false;
        this.isShow = false;
        this.currentPage = 1;
        this.pageSize = 10;
        this.total = 0;
        this.getList();
      } else {
        if (this.$route.query['title']) {
          if (this.$route.query['title'] !== -1) {
            this.title = this.$route.query['title'];
            this.startTime = '';
            this.endTime = '';
            this.top = false;
            this.isShow = false;
            this.currentPage = 1;
            this.pageSize = 10;
            this.total = 0;
            this.getList();
          } else if (this.$route.query['title'] === -1) {
            this.title = '';
            this.startTime = '';
            this.endTime = '';
            this.top = false;
            this.isShow = false;
            this.currentPage = 1;
            this.pageSize = 10;
            this.total = 0;
            this.getList();
          }
        }
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .platform_list {
    .platform_list_top {
      & > div {
        &:nth-child(1) {
          width: 23%;
          max-width: 263px;
        }
      }

      .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 100% !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/announcement/platform-list.vue